"use client";

import { FadeInSection } from "@/components/animations/FadeIn";
import { SectionBackdrop } from "@/components/sections/SectionBackdrop";
import { EventInfoCard } from "@/components/ui/EventInfoCard";
import { useLocale } from "@/lib/locale/locale-provider";
import type { LocationSectionProps } from "@/lib/sections/location.types";

export function LocationSection({ title, cards }: LocationSectionProps) {
  const locale = useLocale();
  const eyebrow = locale === "fr" ? "Lieu" : locale === "en" ? "Location" : "Ort";

  return (
    <SectionBackdrop tone="location">
      <div className="mx-auto max-w-5xl space-y-10">
        <FadeInSection className="mx-auto max-w-2xl space-y-3 text-center">
          <p className="inline-flex items-center justify-center rounded-full border border-white/60 bg-white/55 px-4 py-2 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-emerald-900/75 shadow-[0_12px_28px_rgba(85,101,73,0.08)] backdrop-blur-xl">
            {eyebrow}
          </p>
          <h2 className="font-display text-4xl text-foreground md:text-5xl">
            {title}
          </h2>
        </FadeInSection>

        <div className="grid gap-5 md:grid-cols-2">
          {cards.map((card, index) => (
            <FadeInSection
              key={`${card.label}-${card.title}`}
              delay={index * 0.08}
            >
              <EventInfoCard
                label={card.label}
                title={card.title}
                subtitle={card.subtitle}
                image={card.image}
                linkLabel={card.linkLabel}
                linkHref={card.linkHref}
              />
            </FadeInSection>
          ))}
        </div>
      </div>
    </SectionBackdrop>
  );
}
